import { useEffect } from "react";
import { useMap } from "react-map-gl";

export default function ({name, url}: IMapIconProps) {
    const map = useMap().map!;

    useEffect(() => {
        if (!map.hasImage(name)) {
            map.loadImage(url, (err, img) => {
                if (err) throw err;
                if (!map.hasImage(name)) {
                    map.addImage(name, img!);
                }
            });
        }
    }, [map]);
}

interface IMapIconProps {
    name: string;
    url: string;
}